export const observers = {
  data () {
    return {
      visibleMap: {},  // 动态记录每个模块是否可见
      observer: null,
      refNames: ['section', 'section1', 'section2', 'section3', 'section4', 'section5', 'section6', 'section7'],

    }
  },
  methods: {
    getAnimationClass(refName, animationClass) {
      return this.visibleMap[refName]
          ? `animate__animated ${animationClass}`
          : '';
    }
  },
  mounted() {
    this.$nextTick(()=>{
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.refNames.forEach((refName) => {
            if (entry.target === this.$refs[refName] && entry.isIntersecting) {
              this.$set(this.visibleMap, refName, true);
              this.observer.unobserve(this.$refs[refName]);
            }
          });
        });
      }, {
        threshold: 0.15,
      });
      this.refNames.forEach((refName) => {
        const el = this.$refs[refName];
        this.$set(this.visibleMap, refName, false);
        if (el && el instanceof Element) {
          this.observer.observe(el);
        }
      });
    })
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  },
}